import { z } from 'zod';
import { DecimalString, IsoDateTime, MoneyAmount, UuidString } from '../primitives.js';

/** InventorySnapshot — immutable balance snapshot (period close, reconciliation baseline). */
export const InventorySnapshot = z.object({
  id: UuidString,
  entity_id: UuidString,
  snapshot_at: IsoDateTime,
  item_id: UuidString,
  warehouse_id: UuidString,
  batch_id: UuidString.nullable(),
  balance_qty: DecimalString,
  balance_value: MoneyAmount,
  reason: z.enum(['period_close', 'reconciliation_baseline', 'manual']),
  created_at: IsoDateTime,
});
export type InventorySnapshot = z.infer<typeof InventorySnapshot>;
